export const API_URL = "https://admin.triderapp.com/api";
